import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { Grid, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import { navigationExtensionEmotionStyle } from "./navigationExtensionAllDataStyle";
import { ContentContainer } from "../Container/PageContentContainer";

import CaseAdditionalClientsTooltipIcon from "../Case/CaseAdditionalClientsTooltipIcon/CaseAdditionalClientsTooltipIcon";

import { ProductUnion } from "../../types/ProductUnion";

type NavigationExtensionCaseAccountingPageProps = {
  product: ProductUnion;
};

const NavigationExtensionCaseAccountingPage = ({ product }: NavigationExtensionCaseAccountingPageProps) => {
  const [topOffset, setTopOffset] = useState(69);

  if (!product) {
    return null;
  }

  return (
    <Paper
      square
      ref={(el) => {
        if (el) {
          setTopOffset(el.getBoundingClientRect().top);
        }
      }}
      sx={{ display: { xs: "none", lg: "block" }, ...navigationExtensionEmotionStyle.tabs({ top: topOffset }) }}
    >
      <ContentContainer size={"large"}>
        <Grid container>
          <Grid
            size={{
              xs: 12,
              lg: 3
            }}>
            <Stack
              sx={{
                justifyContent: "center",
                marginLeft: "2rem"
              }}>
              <Stack direction={"row"} spacing={1}>
                <strong>{product.backofficeCase.label}</strong>
                <CaseAdditionalClientsTooltipIcon product={product} fontSize={"small"} />
              </Stack>
              Unser Zeichen: {product.reference}
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 6
            }}>
            <Tabs scrollButtons="auto" value={false} centered>
              <Tab component={Link} to={"#account"} label={"Konto"} />
              <Tab component={Link} to={"#addWiretransfer"} label={"Neue Überweisung"} />
              <Tab component={Link} to={"#selfIssuedReceipt"} label={"Eigenbeleg erstellen"} />
              <Tab component={Link} to={"#addInvoice"} label={"Rechnung erstellen"} />
            </Tabs>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 3
            }}>
            <Typography
              sx={{
                textAlign: "right",
                marginRight: "2rem"
              }}>
              {product.caseInsurance.insurancePolicyNumber && (
                <>Versicherungsnr.: {product.caseInsurance.insurancePolicyNumber}</>
              )}
              <br />
              {product.caseInsurance.caseReferenceNumber && <>Schadennr.: {product.caseInsurance.caseReferenceNumber}</>}
            </Typography>
          </Grid>
        </Grid>
      </ContentContainer>
    </Paper>
  );
};

export default NavigationExtensionCaseAccountingPage;
